import {useEffect} from "react";
import { useLocation, matchRoutes} from "react-router-dom";
import { useSelector } from "react-redux";
import routes from "../../routes";

function Metadata() { 
	const location = useLocation();
	const apps  = useSelector((state) => state.app.apps);

	useEffect(() => {
    const matches = matchRoutes(routes.routes, location);
    const item =  matches?.filter((item) => !item.route.children)[0];
    let title = item?.route.title || 'BI Global'
    if(item?.params.code){
    	const name = apps.filter(i => i.code == item.params.code)[0]?.name || item.params.code
    	title = title.replace(`:name`,name)
    	Object.entries(item.params).map(([k,i]) => {
	    	title = title.replace(`:${k}`,i)
	    })
    }
    document.title = title;
  }, [location, apps]);
}
export default Metadata